import { floatUid } from 'utils/uid';
function getWeekFromDayNumber(dayNumber) {
    return Math.floor((dayNumber - 1) / 7) + 1;
}
export function hoursPerWeekModifier(allocations) {
    const modifiedAllocations = [];
    allocations.forEach((allocation)=>{
        const endDay = allocation.startDay + allocation.duration - 1;
        if (allocation.startDay % 7 === 1 && allocation.duration % 7 === 0) {
            modifiedAllocations.push({
                ...allocation
            });
            return;
        }
        const startWeek = getWeekFromDayNumber(allocation.startDay);
        const endWeek = getWeekFromDayNumber(endDay);
        if (startWeek === endWeek) {
            modifiedAllocations.push({
                ...allocation,
                startDay: (startWeek - 1) * 7 + 1,
                duration: 7,
                minutes: Number((allocation.minutes * allocation.duration / 7).toFixed(4))
            });
            return;
        }
        let days = 0;
        let newStartWeek = startWeek;
        while(startWeek === newStartWeek){
            days += 1;
            newStartWeek = getWeekFromDayNumber(allocation.startDay + days);
        }
        if (days === 7) {
            newStartWeek = startWeek;
        } else {
            const startAllocation = {
                ...allocation,
                id: floatUid(),
                startDay: (startWeek - 1) * 7 + 1,
                duration: 7,
                minutes: Number((allocation.minutes * days / 7).toFixed(4))
            };
            modifiedAllocations.push(startAllocation);
        }
        let newEndWeek = endWeek;
        days = 0;
        while(endWeek === newEndWeek){
            days += 1;
            newEndWeek = getWeekFromDayNumber(endDay - days);
        }
        if (days === 7) {
            newEndWeek = endWeek;
        } else {
            const endAllocation = {
                ...allocation,
                id: floatUid(),
                startDay: (endWeek - 1) * 7 + 1,
                duration: 7,
                minutes: Number((allocation.minutes * days / 7).toFixed(4))
            };
            modifiedAllocations.push(endAllocation);
        }
        if (newStartWeek <= newEndWeek) {
            const middleWeeks = newEndWeek - newStartWeek + 1;
            const middleAllocation = {
                ...allocation,
                id: floatUid(),
                startDay: (newStartWeek - 1) * 7 + 1,
                duration: middleWeeks * 7
            };
            modifiedAllocations.push(middleAllocation);
        }
    });
    return modifiedAllocations;
}
